import { MdClear, MdCheck } from "react-icons/md";
import { IconType } from 'react-icons';
import { hexToRgb } from "../../utils/utils";

interface StatusConfig {
    colorClass: string;
    backgroundColor: string;
    icon?: IconType | null;
    label: string;
}

const statusConfig: Record<string, StatusConfig> = {
    'cumple': {
        colorClass: 'text-indicator-green',
        backgroundColor: "#03D68A",
        icon: MdCheck,
        label: 'Cumple',
    },
    'restringe': {
        colorClass: 'text-indicator-red',
        backgroundColor: "#FF6060",
        icon: MdClear,
        label: 'Restringe',
    },
    '-': {
        colorClass: 'text-system-light-50',
        backgroundColor: '#70787D',
        icon: null,
        label: 'No se evalúa',
    },
    'no aplica': {
        colorClass: 'text-indicator-null',
        backgroundColor: '#FFC0CB',
        icon: null,
        label: '-',
    }
};

interface EvaluationLawsProps {
    evaluacion: string | null;
    width?: string;
    height?: string;
}

const EvaluationLaws = ({ evaluacion, width = 'w-[120px] sm:w-[140px]', height = 'h-[28px]' }: EvaluationLawsProps) => {
 
    const key = evaluacion
        ? evaluacion
            .normalize("NFKC")
            .toLowerCase()
            .trim()
        : '-';
    const { colorClass, backgroundColor, icon: Icon, label } = statusConfig[key] || statusConfig['-'];
    const backgroundRgb = hexToRgb(backgroundColor);

    return (
        <div
            className={`flex items-center gap-1 ${colorClass} ${width} ${height} justify-center rounded-md`}
            style={{ backgroundColor: `rgba(${backgroundRgb}, 0.1)` }}
        >
            {Icon && <Icon />}
            <span className={`${colorClass} text-bmedium`}>{label}</span>
        </div>
    );
};

export default EvaluationLaws